// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file rubykaigi/sponsor_app/expense_line_item_patch.proto (package rubykaigi.sponsor_app, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { ExpenseLineItemInput } from "./expense_report_pb";
import { file_rubykaigi_sponsor_app_expense_report } from "./expense_report_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file rubykaigi/sponsor_app/expense_line_item_patch.proto.
 */
export const file_rubykaigi_sponsor_app_expense_line_item_patch: GenFile = /*@__PURE__*/
  fileDesc("CjNydWJ5a2FpZ2kvc3BvbnNvcl9hcHAvZXhwZW5zZV9saW5lX2l0ZW1fcGF0Y2gucHJvdG8SFXJ1YnlrYWlnaS5zcG9uc29yX2FwcCLUAQoURXhwZW5zZUxpbmVJdGVtUGF0Y2gSTgoRZXhwZW5zZV9saW5lX2l0ZW0YASABKAsyKy5ydWJ5a2FpZ2kuc3BvbnNvcl9hcHAuRXhwZW5zZUxpbmVJdGVtSW5wdXRCBrpIA9gBAxJsCgpmaWVsZF9tYXNrGAIgAygJQli6SFWSAVIYASJOckxSBXRpdGxlUgVub3Rlc1IGYW1vdW50Ugh0YXhfcmF0ZVIKdGF4X2Ftb3VudFIKcHJlbGltaW5hbFIIcG9zaXRpb25SCGZpbGVfaWRzQhHqAg5Sazo6U3BvbnNvckFwcGIGcHJvdG8z", [file_buf_validate_validate, file_rubykaigi_sponsor_app_expense_report]);

/**
 * A change to an expense line item, which the expense report editor sends to create or update
 * one. The fields field_mask names are written from expense_line_item, and the others are left as
 * they are, or at their defaults on a new line item.
 *
 * @generated from message rubykaigi.sponsor_app.ExpenseLineItemPatch
 */
export type ExpenseLineItemPatch = Message<"rubykaigi.sponsor_app.ExpenseLineItemPatch"> & {
  /**
   * Values to write. A field that field_mask names but this leaves unset is cleared: notes and
   * tax_rate to none, file_ids to no files, and preliminal to false. title, amount and tax_amount
   * cannot be cleared, and an unset position keeps the line item where it is.
   *
   * ExpenseLineItemInput's rules are checked only on the fields field_mask names, so a field the
   * patch leaves out is not rejected for being unset. This message's own validation skips them.
   *
   * @generated from field: rubykaigi.sponsor_app.ExpenseLineItemInput expense_line_item = 1;
   */
  expenseLineItem?: ExpenseLineItemInput | undefined;

  /**
   * Fields of expense_line_item to write, named as in the .proto, such as "title" or "file_ids".
   * Naming a field ExpenseLineItemInput lacks is a bad request. position is ignored on a new line
   * item, which is added last.
   *
   * Deprecated: a JSON body without field_mask writes the fields its expense_line_item has, null
   * ones cleared. A body naming no field either way is a bad request.
   *
   * @generated from field: repeated string field_mask = 2;
   */
  fieldMask: string[];
};

/**
 * Describes the message rubykaigi.sponsor_app.ExpenseLineItemPatch.
 * Use `create(ExpenseLineItemPatchSchema)` to create a new message.
 */
export const ExpenseLineItemPatchSchema: GenMessage<ExpenseLineItemPatch> = /*@__PURE__*/
  messageDesc(file_rubykaigi_sponsor_app_expense_line_item_patch, 0);

